import { Navigate } from 'react-router-dom';
import { isExpired } from 'react-jwt';
import { AESDecryption } from '../../utils/Aes';

const RequireNoAuth = ({ children }) => {
    const tokenEncrypted = localStorage.getItem('token');
    if (!tokenEncrypted) {
        return children;
    }

    const token = AESDecryption(tokenEncrypted);
    if (!token || isExpired(token)) {
        return children;
    }
 
    //check for alt reallocation screen
    if(window.location.href.includes("/Meeting-Management/alt-reallocation?token=")){
        window.location.pathname = "/web/Meeting-Management/alt-reallocation";
      }

    return <Navigate to="/home" replace />;
};

export default RequireNoAuth;
